export const isIncludeAlphabets = (value) => new RegExp("[a-zA-Z]").test(value);
export const isNotIncludesSpecSymbols = (value) => new RegExp("^[a-zA-Z0-9._-]+$").test(value);
